export type AdminBillApprovalProps = {
  setData: (field: string, n : any, id: number | null) => void
  payInvoice: (id: number) => void
  approveInvoice: (id: number) => void
  markHistorical: (id: number) => void
  deleteInvoice: (id:number) => void
}

export enum FieldProps {
  Provider = 'provider',
  Total = 'total',
  IssueDate = 'issueDate',
  DueDate = 'dueDate',
  StartDate = 'startDate',
  EndDate = 'endDate',
  ReceiptId = 'receiptId',
}
